/* FCPeffects email signup popup + footer helper (Grok 2026-10-10).
   No tracking. Only network call: a read of /cart.js (popup fix 2026-10-11). Uses localStorage/sessionStorage on this device only, to remember:
   fcpe_su_done (signed up: never show again), fcpe_su_dismissed (closed: hide 30 days),
   fcpe_su_pv / fcpe_su_shown / fcpe_su_src (this session's page views, whether shown, which form was submitted).
   Cookie consent (2026-10-10): the popup never opens while Shopify's cookie banner is on screen or the visitor hasn't
   answered it (Customer Privacy API). Once they answer, the normal trigger applies (9 s timer / desktop exit intent).
   Timing (approved 2026-10-10): first visit, 9 s on the page OR desktop exit intent (mouse leaves through the top,
   armed after 3 s), whichever comes first. At most once per session; closed = hidden 30 days; signed up = never.
   Visitors outside banner regions are unaffected. ?fcpe_popup=test still opens it regardless.
   Popup fix (Grok 2026-10-11, after it covered the cart drawer's checkout button on mobile):
   - Never opens on product pages (incl. the MEGA BUNDLE), MEGA BUNDLE landing pages, cart/checkout/account pages,
     or when the cart has items (cart count in the header, then /cart.js, the only network call, same-origin, read-only).
   - Only from the 2nd page view of the visit onward (9 s timer or desktop exit intent), once per visitor: after it has
     been shown it stays hidden for 30 days (closed = 30 days, signed up = never).
   - Closes by itself on any add to cart, cart update or cart drawer / theme drawer open, and is hidden by CSS whenever a
     drawer is open, so it can never sit above the cart drawer.
   - Mobile: bigger X, full-width "No thanks", and swipe down on the card to close.
   Free plugins (Grok 2026-10-12): window.fcpeSignup.open(source) + [data-fcpe-su-open] buttons (homepage card), shared result handling
   for every form with data-fcpe-su-source (popup, footer, landing page).
   Card signup fix (Grok 2026-10-12): the homepage card now has its own inline form (source home-card); after a signup from it the card
   stays visible on that one reload to show the thank-you, and hides on later visits like before.
   Popup v2 (Grok 2026-10-20, theme "Popup improvements v2 2026-10-20"): the A/B test (popup-test-a/b) is over, everyone gets one version:
   - Desktop (768px and wider): first page view, 8 s on the page OR 40% scroll, whichever comes first; exit intent (mouse leaves
     through the top, desktop with a mouse only, armed after 3 s) stays as a backup.
   - Mobile (below 768px): first page view, 10 s OR 40% scroll. Never on load (the scroll trigger is armed after 2 s), no exit intent.
   - Same caps: once per session, hidden 30 days after it was shown or closed, never after signup, never on cart/checkout/account,
     product pages or the MEGA BUNDLE (product page and landing pages), never while the cart has items.
   - No auto-open for visitors who arrived from an email link this session (utm_medium=email, utm_source=shopify_email or klaviyo,
     Klaviyo _kx / _ke), remembered in sessionStorage fcpe_su_email. Logged-in customers who accept marketing never get the popup
     (snippets/fcpe-signup-popup.liquid doesn't render it).
   - Popup signups are tagged popup-v2 in the hidden tags field (snippets/fcpe-signup-popup.liquid). ?popup_variant is ignored and the old
     fcpe_popup_variant localStorage key / cookie is removed if present.
   - Opening on request (window.fcpeSignup.open / [data-fcpe-su-open], e.g. the product page "free when you join" link) is not limited
     by any of the auto-open rules above.
   Gift Trio design (Grok 2026-10-20): the 3 FREE plugin tiles load their posters + looping videos only when the popup opens and pause on
   close; on the mobile bottom sheet the phone's Back button closes it (one history entry, removed again on any other close). */
(function () {
  'use strict';
  if (window.__fcpeSuLoaded) return; // run once, even if the file is included twice
  window.__fcpeSuLoaded = true;

  // Shopify's hCaptcha on the signup forms (Grok 2026-10-10). On browsers reporting navigator.platform "Linux x86_64",
  // bootstrap-39.0.69.js (snippets/scripts.liquid) moves src to data-src on every script and iframe added to the page.
  // hCaptcha's api.js reads its own src (?onload=...) to start, and its widget lives in iframes, so the form never gets a
  // captcha token and Shopify's captcha script blocks the submit (nothing is posted). Put hCaptcha's src attributes back.
  var HCAP = /^https:\/\/(([a-z0-9-]+\.)*hcaptcha\.com\/|cdn\.shopify\.com\/shopifycloud\/storefront-forms-hcaptcha\/)/i;
  function fixCaptchaScript(sc) {
    var ds = sc.getAttribute('data-src');
    if (!ds || sc.getAttribute('src') || !HCAP.test(ds)) return;
    sc.removeAttribute('data-src');
    sc.setAttribute('src', ds); // already fetched when it was inserted; this only restores what the script reads about itself
    if (sc.getAttribute('type') === 'text/lazyload') sc.setAttribute('type', 'text/javascript');
  }
  function fixCaptchaFrame(f) {
    var ds = f.getAttribute('data-src');
    if (!ds || f.getAttribute('src') || !HCAP.test(ds)) return;
    f.removeAttribute('loading');
    f.removeAttribute('data-src');
    f.setAttribute('src', ds);
  }
  function fixCaptchaFrames(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.tagName === 'IFRAME') { fixCaptchaFrame(root); return; }
    if (root.tagName === 'SCRIPT') { fixCaptchaScript(root); return; }
    if (root.querySelectorAll) {
      var l = root.querySelectorAll('iframe[data-src]'); for (var j = 0; j < l.length; j++) fixCaptchaFrame(l[j]);
      var sl = root.querySelectorAll('script[data-src]'); for (var q = 0; q < sl.length; q++) fixCaptchaScript(sl[q]);
    }
  }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) { var n = muts[m].addedNodes; for (var k = 0; k < n.length; k++) fixCaptchaFrames(n[k]); }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  fixCaptchaFrames(document.documentElement);

  var K_DONE = 'fcpe_su_done', K_DISMISS = 'fcpe_su_dismissed', K_PV = 'fcpe_su_pv', K_SHOWN = 'fcpe_su_shown', K_SRC = 'fcpe_su_src';
  var HIDE_MS = 30 * 24 * 60 * 60 * 1000;
  var DESKTOP_DELAY = 8000, MOBILE_DELAY = 10000; // popup v2 (2026-10-20): desktop 8 s, mobile 10 s, first page view
  var SCROLL_AT = 0.4, SCROLL_ARM_MS = 2000; // or 40% scroll depth, counted from 2 s after load (never on load)
  var BLOCKED = ['cart', 'checkout', 'checkouts', 'account', 'challenge', 'products', 'the-mega-bundle'];
  var MIN_PV = 1; // popup v2: first page view (was 2nd page view before the A/B test)
  var K_EMAIL = 'fcpe_su_email';
  // Popup v2: the A/B test is over. Remove its old variant memory (localStorage + cookie fcpe_popup_variant) if it is still there.
  try { if (window.localStorage.getItem('fcpe_popup_variant') !== null) window.localStorage.removeItem('fcpe_popup_variant'); } catch (e) {}
  try { if (/(?:^|;\s*)fcpe_popup_variant=/.test(document.cookie)) document.cookie = 'fcpe_popup_variant=; path=/; max-age=0; SameSite=Lax'; } catch (e) {}

  function store(type) { try { var s = window[type]; var t = '__fcpe_t'; s.setItem(t, '1'); s.removeItem(t); return s; } catch (e) { return null; } }
  var LS = store('localStorage'), SS = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) {} }
  function del(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }

  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = { get: function () { return null; } }; }
  var posted = params.get('customer_posted') === 'true';
  var testMode = params.get('fcpe_popup') === 'test';
  // Popup v2: visitors who came from an email link don't get the popup automatically for the rest of this session.
  var fromEmail = (function () {
    var m = (params.get('utm_medium') || '').toLowerCase(), so = (params.get('utm_source') || '').toLowerCase();
    return m === 'email' || m === 'e-mail' || so === 'shopify_email' || so.indexOf('klaviyo') > -1 ||
      params.get('_kx') !== null || params.get('_ke') !== null;
  })();
  if (fromEmail) set(SS, K_EMAIL, '1');
  var src = get(SS, K_SRC);
  del(SS, K_SRC);

  var pv = (parseInt(get(SS, K_PV) || '0', 10) || 0) + 1;
  set(SS, K_PV, String(pv));

  // Remember which signup form was submitted (footer or popup) so the right one shows the result after reload.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute) {
      var s = f.getAttribute('data-fcpe-su-source');
      if (s) set(SS, K_SRC, s);
    }
  }, true);

  if (posted) set(LS, K_DONE, '1');

  // Every signup form on the page shares Shopify's 'customer' form result. Only the form that was submitted
  // (remembered in K_SRC) keeps its thank-you or error; the others go back to their normal form.
  // (2026-10-12: generalised from footer-only to every form with data-fcpe-su-source, for the free plugins landing page form.)
  if (src) {
    var suForms = document.querySelectorAll('form[data-fcpe-su-source]');
    for (var fi = 0; fi < suForms.length; fi++) {
      if (suForms[fi].getAttribute('data-fcpe-su-source') === src || suForms[fi].getAttribute('data-fcpe-su-source') === 'popup') continue; // the popup handles itself below
      var fState = suForms[fi].querySelector('[data-fcpe-su-state]');
      if (fState) fState.classList.remove('is-success');
      var fErr = suForms[fi].querySelector('[data-fcpe-su-errors]');
      if (fErr) fErr.parentNode.removeChild(fErr);
    }
  }

  // Free plugins (2026-10-12): buttons with data-fcpe-su-open="<source>" (homepage card) open the popup in place,
  // adding the tag "<source>-signup". If the popup isn't on the page (cart has items, etc.), jump to the footer form.
  // Cards with data-fcpe-su-card hide once this device has signed up.
  // Card signup fix (Grok 2026-10-12, inline form in the homepage card): on the reload right after a signup from a card's own form
  // (customer_posted=true and the submitted source is that card's form), keep that card visible so it shows its thank-you.
  // Later page views on this device still hide every card (fcpe_su_done stays set).
  if (get(LS, K_DONE)) {
    var suCards = document.querySelectorAll('[data-fcpe-su-card]');
    for (var ci = 0; ci < suCards.length; ci++) {
      var cf = posted && src ? suCards[ci].querySelector('form[data-fcpe-su-source]') : null;
      if (cf && cf.getAttribute('data-fcpe-su-source') === src) continue;
      suCards[ci].hidden = true;
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-fcpe-su-open]') : null;
    if (!t) return;
    e.preventDefault();
    if (window.fcpeSignup && window.fcpeSignup.open && window.fcpeSignup.open(t.getAttribute('data-fcpe-su-open'))) return;
    var fe = document.getElementById('FcpeSuFooterEmail');
    if (!fe) return;
    fe.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { try { fe.focus({ preventScroll: true }); } catch (x) {} }, 450);
  });

  var root = document.getElementById('FcpeSuPop');
  if (!root) return;

  var card = root.querySelector('.fcpe-su-pop__card');
  // Popup v2: the popup form's hidden tags field already carries "popup-v2" (Liquid). Strip any old A/B tag, just in case.
  var suTags = root.querySelector('[data-fcpe-su-tags]');
  if (suTags && /popup-test-/.test(suTags.value)) suTags.value = suTags.value.replace(/,\s*popup-test-[ab]/g, '');
  var state = root.querySelector('[data-fcpe-su-state]');
  var pErr = root.querySelector('[data-fcpe-su-errors]');
  var page = document.getElementById('PageContainer');
  var mqMobile = window.matchMedia('(max-width: 768px)'); // layout: bottom card (non-modal) up to 768px, as before
  var mqPhone = window.matchMedia('(max-width: 767px)'); // popup v2 timing rules: "mobile" = below 768px
  var mqPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var isOpen = false, lastFocus = null, timer = null;

  // ---- Popup fix 2026-10-11: cart awareness ----
  var cartHasItems = false;
  function headerCartCount() {
    var els = document.querySelectorAll('.cart-link__bubble-num, [data-cart-count], .cart-count');
    for (var i = 0; i < els.length; i++) { var n = parseInt((els[i].textContent || '').replace(/\D/g, ''), 10); if (n > 0) return n; }
    var b = document.querySelector('.cart-link__bubble--visible');
    return b ? 1 : 0;
  }
  if (headerCartCount() > 0) cartHasItems = true;
  function checkCart(cb) {
    if (cartHasItems || !window.fetch) { cb(); return; }
    var done = false; function fin() { if (!done) { done = true; cb(); } }
    try {
      window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.item_count > 0) cartHasItems = true; fin(); })
        .catch(fin);
    } catch (e) { fin(); }
  }
  function onCartActivity() { // something was added: close and stay closed on this page
    cartHasItems = true;
    clearTimeout(timer);
    if (isOpen) close(false);
  }
  function onDrawerOrModal() { if (isOpen) close(false); } // a drawer/modal opened: close (busy() keeps it from reopening meanwhile)
  document.addEventListener('ajaxProduct:added', onCartActivity);
  document.addEventListener('cart:updated', function (e) {
    var c = e && e.detail && e.detail.cart;
    if (c && c.item_count > 0) onCartActivity();
  });
  ['drawerOpen', 'drawerOpen.CartDrawer', 'quickview:open', 'modalOpen'].forEach(function (ev) {
    document.addEventListener(ev, onDrawerOrModal);
  });
  // Any add-to-cart form submit or click on an add / cart button closes it straight away (capture phase, before the theme).
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '') && !root.contains(f)) onCartActivity();
  }, true);
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target : null;
    if (!el || root.contains(el)) return;
    if (el.closest('[name="add"], .add-to-cart, [data-add-to-cart], .quick-add-btn')) onCartActivity();
    else if (el.closest('.js-drawer-open-cart, .site-nav__link--cart, a[href$="/cart"], [aria-controls="CartDrawer"]')) onDrawerOrModal();
  }, true);
  // Whenever a theme drawer opens (the cart drawer adds .drawer--is-open and js-drawer-open), close it.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (isOpen && document.querySelector('.drawer--is-open, html.js-drawer-open, body.js-drawer-open')) close(false);
    });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var cd = document.getElementById('CartDrawer');
    if (cd) mo.observe(cd, { attributes: true, attributeFilter: ['class'] });
  }

  function blockedPath() {
    var parts = window.location.pathname.split('/');
    for (var i = 0; i < parts.length; i++) { if (BLOCKED.indexOf(parts[i]) > -1) return true; }
    return false;
  }

  function eligible() {
    if (testMode) return true;
    if (!LS || !SS) return false; // can't remember a dismissal, so don't nag
    if (get(LS, K_DONE)) return false;
    var d = parseInt(get(LS, K_DISMISS) || '0', 10);
    if (d && Date.now() - d < HIDE_MS) return false;
    if (get(SS, K_SHOWN)) return false;
    var sh = parseInt(get(LS, K_SHOWN) || '0', 10); // once per visitor (30 days)
    if (sh && Date.now() - sh < HIDE_MS) return false;
    if (pv < MIN_PV) return false;
    if (get(SS, K_EMAIL)) return false; // popup v2: arrived from an email link this session
    if (cartHasItems) return false;
    if (blockedPath()) return false;
    return true;
  }

  // ---- Cookie consent gate ----
  function privacyApi() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.shouldShowBanner === 'function' ? cp : null;
  }
  // Make sure the Customer Privacy API is loaded (the Shopify banner normally loads it already).
  if (!privacyApi() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (e) {}
  }
  function bannerOnScreen() {
    var ids = ['shopify-pc__banner', 'shopify-pc__prefs'];
    for (var i = 0; i < ids.length; i++) {
      var el = document.getElementById(ids[i]);
      if (!el) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < (window.innerHeight || 0)) return true;
    }
    return false;
  }
  function consentUnanswered() {
    var cp = privacyApi();
    if (!cp) return false; // no API: rely on the banner check only
    var show = false;
    try { show = !!cp.shouldShowBanner(); } catch (e) { return false; }
    if (!show) return false; // region doesn't need a banner (or consent already given)
    if (typeof cp.currentVisitorConsent !== 'function') return true;
    try {
      var c = cp.currentVisitorConsent() || {};
      return c.marketing === '' || c.analytics === '' || c.preferences === '';
    } catch (e) { return true; }
  }
  function consentPending() { return bannerOnScreen() || consentUnanswered(); }

  var waitingConsent = false, consentPoll = null;
  function onConsentAnswered() {
    if (!waitingConsent || consentPending()) return;
    waitingConsent = false;
    clearInterval(consentPoll);
    document.removeEventListener('visitorConsentCollected', onConsentEvent);
    // Normal trigger, counted from the moment they answered.
    if (!isOpen) { clearTimeout(timer); timer = setTimeout(tryOpen, mqPhone.matches ? MOBILE_DELAY : DESKTOP_DELAY); }
  }
  function onConsentEvent() { setTimeout(onConsentAnswered, 300); } // let the banner finish hiding
  function waitForConsent() {
    if (waitingConsent) return;
    waitingConsent = true;
    clearTimeout(timer);
    document.addEventListener('visitorConsentCollected', onConsentEvent);
    consentPoll = setInterval(onConsentAnswered, 2000); // fallback if the event is missed
  }

  function busy() {
    if (cartHasItems) return true;
    var a = document.activeElement;
    if (a && a !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    return !!document.querySelector('.js-drawer-open, .modal-open, .drawer--is-open, .is-active.modal');
  }

  function focusables() {
    var list = card.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])');
    var out = [];
    for (var i = 0; i < list.length; i++) { if (list[i].offsetWidth || list[i].offsetHeight || list[i].getClientRects().length) out.push(list[i]); }
    return out;
  }

  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(true); return; }
    if (e.key !== 'Tab' || card.getAttribute('aria-modal') !== 'true') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); card.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === card || !card.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !card.contains(a))) { e.preventDefault(); first.focus(); }
  }

  function open(success) {
    if (isOpen) return;
    isOpen = true;
    clearTimeout(timer);
    set(SS, K_SHOWN, '1');
    if (!success) set(LS, K_SHOWN, String(Date.now()));
    var mobile = mqMobile.matches;
    card.setAttribute('aria-modal', mobile ? 'false' : 'true');
    if (success) {
      state.classList.add('is-success');
      card.setAttribute('aria-labelledby', 'FcpeSuPopDoneTitle');
      card.setAttribute('aria-describedby', 'FcpeSuPopDoneBody');
    }
    loadMedia();
    lastFocus = document.activeElement;
    root.hidden = false;
    window.requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    // Gift Trio (2026-10-20): on the mobile bottom sheet the phone's Back button closes the popup instead of leaving the page.
    if (mobile && window.history && window.history.pushState) {
      try { window.history.pushState({ fcpeSu: 1 }, ''); histPushed = true; } catch (e) {}
    }
    if (!mobile) {
      if (page) page.setAttribute('inert', '');
      // 2026-10-20 CLS fix (Grok, Turner approved): overflow:hidden removes a classic (Windows) scrollbar and the page jumped sideways.
      // Pad the page by the scrollbar width while locked so nothing moves (0 with overlay scrollbars, e.g. macOS: no change there).
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.classList.add('fcpe-su-lock');
      if (sbw > 0) document.documentElement.style.paddingRight = sbw + 'px';
      var input = root.querySelector('input[type="email"]');
      try { (success || !input ? card : input).focus({ preventScroll: true }); } catch (e) { card.focus(); }
    } else {
      try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); }
    }
  }

  // Gift Trio (2026-10-20): the 3 plugin tiles. Posters and videos are only fetched when the popup opens; videos play only while
  // it is open (muted, looping, inline). Reduced motion or data saver: posters only.
  var histPushed = false;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  function loadMedia() {
    var imgs = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].src = imgs[i].getAttribute('data-src'); imgs[i].removeAttribute('data-src'); }
    if (reduceMotion || saveData) return;
    var vids = root.querySelectorAll('.fcpe-gt__m video');
    for (var j = 0; j < vids.length; j++) {
      var v = vids[j], ds = v.getAttribute('data-src');
      v.muted = true;
      if (ds) {
        v.removeAttribute('data-src');
        v.addEventListener('playing', function () { this.classList.add('is-playing'); });
        v.preload = 'auto';
        v.src = ds;
      }
      try { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
    }
  }
  function pauseMedia() {
    var vids = root.querySelectorAll('.fcpe-gt__m video');
    for (var j = 0; j < vids.length; j++) { try { if (!vids[j].paused) vids[j].pause(); } catch (e) {} }
  }
  window.addEventListener('popstate', function () {
    if (!isOpen || !histPushed) return;
    histPushed = false; // the entry is already gone
    close(true);
  });

  function close(dismissed) {
    if (!isOpen) return;
    isOpen = false;
    if (dismissed && !state.classList.contains('is-success')) set(LS, K_DISMISS, String(Date.now()));
    root.classList.remove('is-open');
    root.hidden = true;
    pauseMedia();
    if (histPushed) { // Back-button support: drop the history entry added on open (mobile)
      histPushed = false;
      try { if (window.history.state && window.history.state.fcpeSu) window.history.back(); } catch (e) {}
    }
    document.removeEventListener('keydown', onKey);
    if (page) page.removeAttribute('inert');
    document.documentElement.classList.remove('fcpe-su-lock');
    document.documentElement.style.paddingRight = '';
    if (lastFocus && lastFocus.focus && document.documentElement.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // Mobile: swipe the card down to close it.
  var tsY = null;
  card.addEventListener('touchstart', function (e) {
    if (mqMobile.matches && e.touches && e.touches.length === 1 && card.scrollTop <= 0) tsY = e.touches[0].clientY; else tsY = null;
  }, { passive: true });
  card.addEventListener('touchmove', function (e) {
    if (tsY === null || !e.touches || !e.touches[0]) return;
    var d = e.touches[0].clientY - tsY;
    card.style.transform = d > 0 ? 'translateY(' + d + 'px)' : '';
  }, { passive: true });
  card.addEventListener('touchend', function (e) {
    if (tsY === null) return;
    var y = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : tsY;
    var d = y - tsY; tsY = null; card.style.transform = '';
    if (d > 50) close(true);
  }, { passive: true });

  var dismissers = root.querySelectorAll('[data-fcpe-su-dismiss]');
  for (var i = 0; i < dismissers.length; i++) {
    dismissers[i].addEventListener('click', function (e) { e.preventDefault(); close(true); });
  }

  // Public hook (2026-10-12): open the popup on request, e.g. from the homepage free plugins card.
  window.fcpeSignup = {
    open: function (source) {
      if (isOpen) return true;
      var tg = root.querySelector('[data-fcpe-su-tags]');
      if (tg && source && /^[a-z0-9-]+$/.test(source) && tg.value.indexOf(source + '-signup') < 0) tg.value += ', ' + source + '-signup';
      clearTimeout(timer);
      open(false);
      return true;
    }
  };

  // After a popup signup, the page reloads: show the thank-you in the popup.
  if (posted && src === 'popup') { open(true); return; }
  // Popup signup came back with an error (e.g. invalid email): reopen so it can be fixed.
  if (pErr && src === 'popup') { open(false); return; }
  if (pErr) pErr.parentNode.removeChild(pErr);

  if (!eligible()) return;

  if (testMode) { timer = setTimeout(function () { open(false); }, 600); return; }

  function tryOpen() {
    if (isOpen || !eligible()) return;
    if (consentPending()) { waitForConsent(); return; }
    if (busy()) { if (!cartHasItems) timer = setTimeout(tryOpen, 5000); return; }
    checkCart(function () { if (!isOpen && eligible() && !busy() && !consentPending()) open(false); });
  }

  // Popup v2 timed trigger: first page view, 8 s (desktop) / 10 s (below 768px). If the cookie banner is still unanswered,
  // wait for the answer first, then start the delay.
  if (consentPending()) waitForConsent();
  else timer = setTimeout(tryOpen, mqPhone.matches ? MOBILE_DELAY : DESKTOP_DELAY);

  // Popup v2 scroll trigger (desktop and mobile): 40% scroll depth, whichever comes first with the timer. Same eligibility, consent
  // and busy checks via tryOpen(). Only counts scrolling after the first 2 s, so it can't fire on load (e.g. a restored scroll position).
  var scrollArmed = false;
  setTimeout(function () { scrollArmed = true; }, SCROLL_ARM_MS);
  var onScroll = function () {
    if (!scrollArmed || isOpen) return;
    var de = document.documentElement, h = Math.max(de.scrollHeight - window.innerHeight, 1);
    if ((window.pageYOffset || de.scrollTop) / h < SCROLL_AT) return;
    if (waitingConsent) return; // cookie banner still unanswered: the timer starts once it is answered
    window.removeEventListener('scroll', onScroll);
    clearTimeout(timer);
    tryOpen();
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  // Exit intent: desktop (768px and wider) with a mouse only, armed after 3 s. Never on phones.
  if (!mqPhone.matches && mqPointer.matches) {
    var armed = false;
    setTimeout(function () { armed = true; }, 3000);
    var onOut = function (e) {
      if (!armed || isOpen) return;
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 0) return;
      if (mqPhone.matches || !eligible() || busy() || consentPending()) return;
      document.removeEventListener('mouseout', onOut);
      checkCart(function () { if (!isOpen && eligible() && !busy()) open(false); });
    };
    document.addEventListener('mouseout', onOut);
  }
})();
